import React from 'react'
import Banner from '../Components/Banner/Banner'
import CoinsTable from '../Components/CoinsTable'

function Homepage() {
  return (
    <>
    <Banner/>
    <CoinsTable/>
    </>
  )
}

export default Homepage